// Codigo del menu (data-entry) que, en vez de navegar, abre el dialogo de registro.
export const NON_CONFORMING_PRODUCT_REGISTRATION_CODE = 'non-conforming-product-registration'

// Estado global del dialogo de registro de Producto No Conforme. El dialogo vive en el
// Navbar para poder abrirse desde el menu lateral, la lista de secciones y el reporte.
// lastCreatedAt cambia cada vez que se registra un producto, para que el reporte se refresque.
export function useNonConformingProductDialog() {
  const open = useState<boolean>('non-conforming-product-dialog-open', () => false)
  const lastCreatedAt = useState<number>('non-conforming-product-last-created-at', () => 0)
  return { open, lastCreatedAt }
}
